export const gettersTypes = {
  count: '[administration] user list count',
  adminCompanyList: '[administration] company list',
};

const getters = {
  [gettersTypes.count]: (state) => {
    return state.count;
  },

  [gettersTypes.adminCompanyList]: (state) => {
    if (!state.companyList && !state.companyList.length) return [];

    return state.companyList
      .filter((company) => company.company_name)
      .sort((a, b) => a.company_id - b.company_id)
      .map((company) => ({
        company_id: company.company_id,
        name: company.company_name,
      }));
  },
};

export default getters;
